export var PdfViewerInteractionMode;
(function (PdfViewerInteractionMode) {
    PdfViewerInteractionMode[PdfViewerInteractionMode["TextSelection"] = 0] = "TextSelection";
    PdfViewerInteractionMode[PdfViewerInteractionMode["Pan"] = 1] = "Pan";
})(PdfViewerInteractionMode || (PdfViewerInteractionMode = {}));
